import {css} from "@panda/css";

import animatedDotsIcon from "./img/animated-dots.svg";

export function ChatBotDotsAnimation() {
    return <object className={animation} type="image/svg+xml" data={animatedDotsIcon} />;
}

const animation = css({
    width: "6rem",
    height: "3.2rem"
});
import {css} from "@panda/css";

import animatedDotsIcon from "./img/animated-dots.svg";

export function ChatBotDotsAnimation() {
    return <object className={animation} type="image/svg+xml" data={animatedDotsIcon} />;
}

const animation = css({
    width: "6rem",
    height: "3.2rem"
});
